module.exports = __webpack_public_path__ + "img/888003526.8aa84cb2.png";